import { TagIcon } from "@phosphor-icons/react/dist/ssr/Tag";
import { useState } from "react";

import { Spinner } from "@up/ui";

import RemoveButton from "./RemoveButton";

import { COUPON_AMOUNT_TYPE, logError } from "@up/data";

import type { TCoupon } from "@up/data";

type Props = {
  item: TCoupon;
  removeFn?: (code: string) => void;
};

export function DiscountLineItem({ item, removeFn }: Props) {
  const [isDeleting, setIsDeleting] = useState(false);

  const isRemovable = removeFn && !isDeleting;

  const handleRemove = async function () {
    if (removeFn) {
      setIsDeleting(true);
      try {
        await removeFn(item.code);
      } catch (err) {
        setIsDeleting(false);
        logError({
          action: "DISCOUNT_REMOVE",
          error: err,
          context: { code: item.code },
        });
      }
    }
  };

  return (
    <div
      className="checkout-discount-list-item items-center animation-fade-in pt-2"
      data-testid="checkout-discount-list-item"
    >
      <div
        className="flex items-center gap-1 pr-4 text-ellipsis overflow-hidden whitespace-nowrap"
        data-testid="checkout-discount-code"
      >
        <TagIcon size={18} color="#40530e" />
        <span
          className="checkout-token text-xs"
          style={{ fontFamily: "var(--checkout-font-monospace)" }}
        >
          {item.code}
        </span>
      </div>

      <div
        className="relative flex"
        data-testid="checkout-discount-list-item-remove"
      >
        {isDeleting && <Spinner />}
        {isRemovable && (
          <span className="relative -top-[2px]">
            <RemoveButton onClick={handleRemove} />
          </span>
        )}
      </div>

      <div
        className="checkout-discount-money flex justify-end text-sm"
        style={{ fontFamily: "var(--checkout-font-monospace)" }}
      >
        {item.formattedAmount}
        {item.amountType === COUPON_AMOUNT_TYPE.CURRENCY ? "usd" : null}
      </div>
    </div>
  );
}
